__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['one-ap-root'].baseUrl;
import ModuleContainer from './components/OneAP';
export default ModuleContainer;
;
if (!global.BROWSER) {
  ModuleContainer.appConfig = Object.assign({}, ModuleContainer.appConfig, {
    appCompatibility: "5.x || 6.x"
  });
}